import type { Cin7SaleSummary } from "@/api/dtos";
import type { SaleSummary } from "@/api/sale/_models/Sale";

export const toSaleSummaryFromCin7SaleSummary = (
  dto: Cin7SaleSummary,
): SaleSummary => {
  return {
    id: dto.SaleID,
    orderNumber: dto.OrderNumber,
    customer: dto.Customer,
    customerId: dto.CustomerID,
    status: dto.Status,
    orderDate: dto.OrderDate,
    invoiceNumber: dto.InvoiceNumber,
    invoiceAmount: dto.InvoiceAmount,
    paidAmount: dto.PaidAmount,
    fulfilmentStatus: dto.FulFilmentStatus,
    shippingStatus: dto.CombinedShippingStatus,
    paymentStatus: dto.CombinedPaymentStatus,
  };
};
